import React from 'react';
export const CommingSoonBigSign = () => (
  <svg width="126px" height="102px" viewBox="0 0 126 102" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-267.000000, -1688.000000)">
        <g transform="translate(267.000000, 1688.000000)">
          <g>
            <path
              d="M100.0269,22.8647 L100.0269,24.4237"
              stroke="#1997C3"
              strokeLinecap="round"
            />
            <path
              d="M100.0269,27.5395 L100.0269,29.0985"
              stroke="#1997C3"
              strokeLinecap="round"
            />
            <path
              d="M103.1436,25.9819 L101.5846,25.9819"
              stroke="#1997C3"
              strokeLinecap="round"
            />
            <path
              d="M98.4683,25.9819 L96.9093,25.9819"
              stroke="#1997C3"
              strokeLinecap="round"
            />
            <path
              d="M34.7481,1.892 C34.7481,2.463 34.2851,2.927 33.7131,2.927 C33.1421,2.927 32.6781,2.463 32.6781,1.892 C32.6781,1.321 33.1421,0.857 33.7131,0.857 C34.2851,0.857 34.7481,1.321 34.7481,1.892"
              fill="#F4C410"
            />
            <path
              d="M19.9019,10.6293 L19.9019,12.7023"
              stroke="#D7238C"
              strokeLinecap="round"
            />
            <path
              d="M19.9019,16.8481 L19.9019,18.9211"
              stroke="#D7238C"
              strokeLinecap="round"
            />
            <path
              d="M24.0479,14.7748 L21.9749,14.7748"
              stroke="#D7238C"
              strokeLinecap="round"
            />
            <path
              d="M17.8291,14.7748 L15.7561,14.7748"
              stroke="#D7238C"
              strokeLinecap="round"
            />
            <g transform="translate(39.000000, 37.710000)">
              <path d="M0.5923,0.0043 L0.5923,12.7513" fill="#FFFFFF" />
              <path
                d="M0.5923,0.0043 L0.5923,12.7513"
                stroke="#E3E6E7"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <g transform="translate(89.000000, 37.710000)">
              <path d="M0.2261,0.0043 L0.2261,12.7513" fill="#FFFFFF" />
              <path
                d="M0.2261,0.0043 L0.2261,12.7513"
                stroke="#E3E6E7"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <g transform="translate(23.000000, 45.710000)">
              <path
                d="M0.4634,12.8978 L0.6844,25.6228 C0.6944,26.2998 1.2534,26.8408 1.9314,26.8308 L78.8484,25.6098 C79.5264,25.5988 80.0674,25.0408 80.0574,24.3618 L79.6814,1.8908 C79.6714,1.2118 79.1124,0.6708 78.4344,0.6818 L0.4424,1.9788 L0.5224,6.3928"
                fill="#FFFFFF"
              />
              <path
                d="M0.4634,12.8978 L0.6844,25.6228 C0.6944,26.2998 1.2534,26.8408 1.9314,26.8308 L78.8484,25.6098 C79.5264,25.5988 80.0674,25.0408 80.0574,24.3618 L79.6814,1.8908 C79.6714,1.2118 79.1124,0.6708 78.4344,0.6818 L0.4424,1.9788 L0.5224,6.3928"
                stroke="#73509D"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <g transform="translate(84.000000, 67.710000)">
              <path d="M2.9038,0.5277 L0.2228,0.5467" fill="#FFFFFF" />
              <path
                d="M2.9038,0.5277 L0.2228,0.5467"
                stroke="#E3E6E7"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <g transform="translate(90.000000, 61.710000)">
              <polyline
                fill="#FFFFFF"
                points="9.9512 0.184 10.0272 6.436 0.6562 6.501"
              />
              <polyline
                stroke="#E3E6E7"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="9.9512 0.184 10.0272 6.436 0.6562 6.501"
              />
            </g>
            <path
              d="M30.8711,59.81 L30.8711,59.793 C30.8481,58.143 32.0741,56.773 33.8581,56.749 C34.9531,56.734 35.6141,57.09 36.1601,57.613 L35.3591,58.563 C34.9061,58.162 34.4471,57.918 33.8661,57.926 C32.8861,57.941 32.1931,58.763 32.2071,59.758 L32.2071,59.775 C32.2211,60.77 32.9201,61.591 33.9151,61.578 C34.5791,61.569 34.9821,61.297 35.4321,60.876 L36.2571,61.687 C35.6691,62.333 35.0101,62.741 33.8901,62.756 C32.1811,62.779 30.8941,61.478 30.8711,59.81"
              fill="#812D92"
            />
            <path
              d="M41.6602,59.6625 L41.6602,59.6465 C41.6462,58.6505 40.9052,57.8305 39.8762,57.8445 C38.8482,57.8595 38.1462,58.6825 38.1602,59.6775 L38.1602,59.6935 C38.1742,60.6885 38.9142,61.5095 39.9422,61.4955 C40.9722,61.4805 41.6742,60.6585 41.6602,59.6625 M36.8252,59.7285 L36.8252,59.7125 C36.8022,58.0615 38.0842,56.6905 39.8762,56.6675 C41.6682,56.6425 42.9732,57.9605 42.9962,59.6105 L42.9962,59.6285 C43.0182,61.2785 41.7342,62.6485 39.9422,62.6725 C38.1502,62.6985 36.8482,61.3795 36.8252,59.7285"
              fill="#812D92"
            />
            <polygon
              fill="#812D92"
              points="44.0894 56.7094 45.4664 56.6894 47.0274 59.1254 48.5194 56.6484 49.8974 56.6304 49.9764 62.4374 48.7064 62.4544 48.6534 58.6624 47.0554 61.1654 47.0214 61.1664 45.3694 58.7324 45.4214 62.4994 44.1684 62.5174"
            />
            <polygon
              fill="#812D92"
              points="51.3443 56.6098 52.6213 56.5928 52.7003 62.3998 51.4233 62.4178"
            />
            <polygon
              fill="#812D92"
              points="54.0708 56.5736 55.2498 56.5566 58.0188 60.0946 57.9698 56.5196 59.2308 56.5026 59.3098 62.3096 58.2238 62.3246 55.3618 58.6716 55.4118 62.3626 54.1498 62.3806"
            />
            <path
              d="M60.4043,59.4076 L60.4043,59.3906 C60.3813,57.7406 61.6493,56.3696 63.4053,56.3456 C64.4513,56.3316 65.0863,56.6046 65.6983,57.1106 L64.9073,58.0926 C64.4553,57.7246 64.0523,57.5146 63.3803,57.5236 C62.4513,57.5366 61.7263,58.3686 61.7403,59.3546 L61.7403,59.3726 C61.7543,60.4336 62.4943,61.2036 63.5223,61.1896 C63.9873,61.1836 64.3993,61.0626 64.7193,60.8256 L64.7093,59.9966 L63.4243,60.0126 L63.4093,58.9096 L65.9313,58.8756 L65.9643,61.3966 C65.3733,61.9106 64.5583,62.3376 63.4963,62.3516 C61.6893,62.3766 60.4273,61.1256 60.4043,59.4076"
              fill="#812D92"
            />
            <path
              d="M69.2774,61.3266 L70.0204,60.4126 C70.5494,60.8376 71.1004,61.1026 71.7644,61.0946 C72.2874,61.0876 72.5984,60.8756 72.5934,60.5356 L72.5934,60.5186 C72.5894,60.1946 72.3884,60.0316 71.4144,59.7966 C70.2414,59.5146 69.4814,59.1986 69.4644,58.0476 L69.4644,58.0296 C69.4514,56.9756 70.2884,56.2676 71.4744,56.2516 C72.3204,56.2396 73.0464,56.4956 73.6404,56.9606 L72.9904,57.9316 C72.4704,57.5836 71.9624,57.3736 71.4734,57.3806 C70.9844,57.3866 70.7294,57.6146 70.7334,57.8966 L70.7334,57.9126 C70.7384,58.2946 70.9884,58.4176 71.9964,58.6596 C73.1794,58.9506 73.8474,59.3646 73.8614,60.3766 L73.8614,60.3926 C73.8774,61.5466 73.0064,62.2056 71.7544,62.2226 C70.8754,62.2346 69.9834,61.9396 69.2774,61.3266"
              fill="#812D92"
            />
            <path
              d="M79.5332,59.1459 L79.5332,59.1289 C79.5192,58.1329 78.7782,57.3139 77.7492,57.3289 C76.7212,57.3419 76.0192,58.1649 76.0332,59.1599 L76.0332,59.1769 C76.0472,60.1719 76.7872,60.9939 77.8152,60.9779 C78.8452,60.9639 79.5472,60.1419 79.5332,59.1459 M74.6982,59.2109 L74.6982,59.1959 C74.6752,57.5449 75.9572,56.1749 77.7492,56.1499 C79.5412,56.1249 80.8462,57.4429 80.8692,59.0939 L80.8692,59.1109 C80.8912,60.7619 79.6072,62.1309 77.8152,62.1569 C76.0232,62.1809 74.7212,60.8629 74.6982,59.2109"
              fill="#812D92"
            />
            <path
              d="M86.5816,59.0502 L86.5816,59.0332 C86.5676,58.0372 85.8266,57.2172 84.7976,57.2322 C83.7686,57.2462 83.0666,58.0692 83.0816,59.0642 L83.0816,59.0812 C83.0946,60.0752 83.8346,60.8962 84.8636,60.8822 C85.8936,60.8682 86.5956,60.0452 86.5816,59.0502 M81.7456,59.1152 L81.7456,59.1002 C81.7216,57.4482 83.0056,56.0782 84.7976,56.0542 C86.5896,56.0292 87.8936,57.3472 87.9156,58.9972 L87.9156,59.0152 C87.9376,60.6652 86.6556,62.0352 84.8636,62.0602 C83.0716,62.0852 81.7686,60.7662 81.7456,59.1152"
              fill="#812D92"
            />
            <polygon
              fill="#812D92"
              points="89.0093 56.0971 90.1883 56.0801 92.9573 59.6181 92.9083 56.0431 94.1693 56.0261 94.2483 61.8331 93.1623 61.8481 90.3003 58.1951 90.3503 61.8861 89.0883 61.9041"
            />
            <path
              d="M118.1382,33.5287 C99.7722,35.9417 88.0012,37.3607 63.7832,37.3607 C37.2992,37.3607 23.6112,35.6647 4.3812,32.8247"
              stroke="#EB1322"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <polygon
              stroke="#DDE4E4"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="4.793 100.789 8.699 100.789 8.699 36.623 4.793 36.623"
            />
            <path
              d="M0.5484,100.7895 L13.5364,100.7895"
              stroke="#DDE4E4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <polygon
              stroke="#DDE4E4"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="115.853 100.754 119.759 100.754 119.759 36.588 115.853 36.588"
            />
            <path
              d="M10.2022,33.1674 C10.2022,35.0764 8.6552,36.6234 6.7452,36.6234 C4.8372,36.6234 3.2892,35.0764 3.2892,33.1674 C3.2892,31.2584 4.8372,29.7114 6.7452,29.7114 C8.6552,29.7114 10.2022,31.2584 10.2022,33.1674"
              fill="#FFFFFF"
            />
            <path
              d="M10.2022,33.1674 C10.2022,35.0764 8.6552,36.6234 6.7452,36.6234 C4.8372,36.6234 3.2892,35.0764 3.2892,33.1674 C3.2892,31.2584 4.8372,29.7114 6.7452,29.7114 C8.6552,29.7114 10.2022,31.2584 10.2022,33.1674 Z"
              stroke="#F4C410"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M121.5967,33.1674 C121.5967,35.0764 120.0487,36.6234 118.1397,36.6234 C116.2307,36.6234 114.6837,35.0764 114.6837,33.1674 C114.6837,31.2584 116.2307,29.7114 118.1397,29.7114 C120.0487,29.7114 121.5967,31.2584 121.5967,33.1674"
              fill="#FFFFFF"
            />
            <path
              d="M121.5967,33.1674 C121.5967,35.0764 120.0487,36.6234 118.1397,36.6234 C116.2307,36.6234 114.6837,35.0764 114.6837,33.1674 C114.6837,31.2584 116.2307,29.7114 118.1397,29.7114 C120.0487,29.7114 121.5967,31.2584 121.5967,33.1674 Z"
              stroke="#F4C410"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M111.6084,100.7543 L124.5964,100.7543"
              stroke="#DDE4E4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
